import { APP_SET_NAVIGATION_STATUS, HIDE_SNACK } from '@/store/MUTATIONS-TYPES'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { VList, VListGroup, VListItem, VListItemIcon, VListItemTitle, VNavigationDrawer, VSpacer, VAppBarNavIcon, VIcon } from 'vuetify/lib'

import './Menu.scss'
import { User } from '@/interfaces/IUser'
import { MenuRoute } from '@/router/menuRoute'
import { RULES } from '@/constants'
import { ROUTERS } from '@/router/ROUTERS'
import { Icons } from '@/assets/icons'
import { CaptureEvent, Events } from '@/services/AmplitudeService'

@Component({})
export default class AppMenu extends Vue {
	menuValue: any
	openMenuGroups: Record<string, boolean> = {}

	menuList: Array<MenuRoute> = [
		new MenuRoute('Início', Icons.Home, ROUTERS.HOME, { exact: true, rules: undefined }),
		new MenuRoute('Dashboard', Icons.TrendingUp, ROUTERS.DASHBOARD.PROJECOES, { exact: true, rules: [RULES.ISOLVE_MENU_DASHBOARD] }, [
			new MenuRoute('Franquias', '', ROUTERS.DASHBOARD.FRANQUIA, { exact: true, rules: undefined }),
			new MenuRoute('Credito Imobiliario', '', ROUTERS.DASHBOARD.ANALISTA_CREDITO_IMOBILIARIO, { exact: true, rules: undefined }),
			new MenuRoute('Rank Produtividade', '', ROUTERS.DASHBOARD.PRODUTIVIDADE, { exact: true, rules: undefined })
		]),
		new MenuRoute('Simulador', Icons.Offer, ROUTERS.CREDITO_IMOBILIARIO.SIMULADOR.MAIN, {
			exact: true,
			rules: [RULES.ISOLVE_MENU_SIMULADOR]
		}),
		new MenuRoute('Novos compradores', Icons.People, ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.GERENCIAR, {
			exact: true,
			rules: [RULES.ISOLVE_MENU_PRE_ANALISE]
		}),

		new MenuRoute('Minhas propostas', Icons.Document, ROUTERS.PROPOSTAS.LISTA, {
			exact: true,
			rules: [RULES.ISOLVE_MENU_PROPOSTAS]
		}),

		new MenuRoute('Administrativo', Icons.Settings, '', { exact: true, rules: undefined }, [
			new MenuRoute('Parametrizações', '', '', { exact: true, rules: [RULES.ISOLVE_MENU_ADM_PARAMETRIZACAO] }, [
				new MenuRoute('Canal de Franquia', '', ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.CANAL_FRANQUIA, {
					exact: true,
					rules: [RULES.ISOLVE_MENU_ADM_FRANQUIAS]
				}),
				new MenuRoute('Crédito Imobiliario', '', ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.CREDITO_IMOBILIARIO, {
					exact: true,
					rules: undefined
				}),
				new MenuRoute('Meta Consultores', '', ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.META_CONSULTORES, {
					exact: true,
					rules: [RULES.ISOLVE_MENU_ADM_PARAMETRIZACAO]
				})
			]),
			new MenuRoute('Parceiros', '', ROUTERS.ADMINISTRATIVO.PARCEIROS, {
				exact: true,
				rules: [RULES.ISOLVE_MENU_ADM_PARCEIROS]
			}),
			new MenuRoute('Vincular Parceiro Grupo', '', ROUTERS.ADMINISTRATIVO.GRUPO_VINCULO_PARCEIRO, {
				exact: true,
				rules: [RULES.ISOLVE_MENU_ADM_ROTINAS]
			}),
			new MenuRoute('Monitoramento Robôs', '', ROUTERS.ADMINISTRATIVO.MONITORAMENTO.ROBOS, {
				exact: true,
				rules: [RULES.ISOLVE_MENU_ADM_MONITORAMENTO_ROBOS]
			}),

			new MenuRoute('Usuários', '', ROUTERS.ADMINISTRATIVO.USUARIOS, {
				exact: true,
				rules: [RULES.ISOLVE_MENU_ADM_USERS]
			}),

			new MenuRoute('Acionamento Franquia', '', ROUTERS.ADMINISTRATIVO.ACIONAMENTO, {
				exact: true,
				rules: [RULES.ISOLVE_MENU_ADM_ACIONAMENTO]
			})
		]),

		new MenuRoute('Fechamento financeiro', Icons.Money, '', { exact: true, rules: [RULES.ISOLVE_MENU_CLOSING] }, [
			new MenuRoute('Fechamento financeiro', '', ROUTERS.CLOSING, { exact: true, rules: undefined }),
			new MenuRoute('Relatório - Acompanhamento de Minutas', '', ROUTERS.CLOSING_MINUTAS_REPORT, { exact: true, rules: undefined })
		])
	]

	private render(createElement: any) {
		return (
			<VNavigationDrawer app permanent mini-variant={this.isExpanded} class="nav-app d-flex" data-tour-step-menu="9" width="300">
				<VAppBarNavIcon onClick={this.toggleNavigation} />
				<VList class="mt-5 pl-0" nav>
					{this.renderMenu(createElement)}
				</VList>
			</VNavigationDrawer>
		)
	}

	get filteredMenu() {
		return this.menuList
	}

	get userCompleteName() {
		const { state } = this.$store
		return state.user?.name
	}

	get accountUrl() {
		return import.meta.env.VUE_APP_API_AUTH
	}

	get isExpanded() {
		const { state } = this.$store
		return state.app.navigationExpand
	}
	get snackbar() {
		const { state } = this.$store
		return state.app.snackbar
	}

	set snackbar(value: boolean) {
		const { commit } = this.$store
		commit(HIDE_SNACK)
	}

	private renderMenu(h: any) {
		return (
			<VList vModel={this.menuValue} dense>
				{this.filteredMenu.map((u) => (u.children != undefined ? this.renderGroupMenu(u) : this.renderItemMenu(u)))}
			</VList>
		)
	}

	private renderGroupMenu(item: any) {
		if (item.children == undefined || this.isCurrentUserAllowedChildren(item.children))
			if (this.isCurrentUserAllowed(item.rules) || item.rules == undefined)
				return (
					<VListGroup
						no-action
						color="primary"
						value={this.isMenuGroupOpen(item)}
						onInput={(open: boolean) => this.setMenuGroupOpen(item.text, open)}
					>
						<template slot="activator">
							<VListItem {...{ item }} class={{ 'pa-0': true, parentMenuHeader: item.isActive }}>
								<VListItemIcon /*onClick={!this.toggleNavigation}*/>
									<VIcon /*onClick={this.toggleNavigation}*/>{item.prependIcon}</VIcon>
								</VListItemIcon>
								<VListItemTitle style={{ padding: 0 }}>{item.text}</VListItemTitle>
							</VListItem>
						</template>
						{item.children.map((item: any) => (item.children ? this.renderSubGroupMenu(item) : this.renderItemMenu(item)))}
					</VListGroup>
				)
	}

	private renderSubGroupMenu(item: any) {
		if (item.children == undefined || this.isCurrentUserAllowedChildren(item.children))
			if (this.isCurrentUserAllowed(item.rules) || item.rules == undefined)
				return (
					<VListGroup no-action sub-group {...{ item }} color="primary" onClick={() => this.updateMenuActiveState(item.to?.name)}>
						<template slot="activator">
							<VListItem class="pa-0 parentMenuHeader">
								<VListItemIcon /*onClick={!this.toggleNavigation}*/>
									<VIcon /*onClick={this.toggleNavigation}*/>{item.prependIcon}</VIcon>
								</VListItemIcon>
								<VListItemTitle>{item.text}</VListItemTitle>
							</VListItem>
						</template>
						{item.children.map(this.renderItemMenu)}
					</VListGroup>
				)
	}

	private renderItemMenu(item: any) {
		if (this.isCurrentUserAllowed(item.rules) || item.rules == undefined)
			return (
				<VListItem
					exact={item.exact}
					to={item.to}
					{...{ item }}
					onClick={() => {
						this.updateMenuActiveState(item.to?.name)
						//this.toggleNavigation()
						this.trackClick(item.text)
					}}
					color="primary"
					class={{ 'active-menu': item.isActive }}
				>
					{item.prependIcon && (
						<VListItemIcon /*onClick={this.toggleNavigation}*/>
							<VIcon /*onClick={this.toggleNavigation}*/>{item.prependIcon}</VIcon>
						</VListItemIcon>
					)}
					<VListItemTitle style={{ padding: 0 }}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							{item.text}
							{item.tag && (
								<div class="menu-tag">
									<span>{item.tag}</span>
								</div>
							)}
						</div>
					</VListItemTitle>
				</VListItem>
			)
	}

	/**
	 * Set the active state of the menu item based on the route name
	 * @param routeName the route name
	 */
	private updateMenuActiveState(routeName: any) {
		this.menuList.forEach((menu: any) => {
			if (menu.children) {
				menu.isActive = false

				menu.children.forEach((child: any) => {
					child.isActive = routeName == child.to?.name
					if (child.isActive) menu.isActive = true
				})

				if (menu.isActive) {
					this.$set(this.openMenuGroups, menu.text, true)
				}
			} else {
				menu.isActive = routeName == menu.to?.name
			}
		})
	}

	private isMenuGroupOpen(item: MenuRoute) {
		return item.isActive || Boolean(this.openMenuGroups[item.text])
	}

	private setMenuGroupOpen(groupName: string, open: boolean) {
		this.$set(this.openMenuGroups, groupName, open)
	}

	get currentUser() {
		const { state } = this.$store
		return state.user as User.IUser
	}

	get currentTheme() {
		return this.$vuetify.theme.dark ? 'grey-dark' : 'white'
	}

	isCurrentUserAllowed(rules: string[]) {
		if (rules && rules.length > 0) {
			const isUserRuleExists = rules.find((rule) => this.currentUser.rules.includes(rule))
			return isUserRuleExists != undefined
		}

		if (rules && rules.length == 0) return true

		return false
	}

	isCurrentUserAllowedChildren(children: Array<MenuRoute>) {
		if (children && children.length > 0) {
			const anyChildrenRulesValid = children.find((c) => c.rules == undefined || this.isCurrentUserAllowed(c.rules))
			return anyChildrenRulesValid != undefined
		}

		if (children && children.length == 0) return true

		return false
	}

	get isCompliance(): boolean {
		const { state } = this.$store
		return state.user.rules.includes(RULES.ISOLVE_PARCEIRO_COMPLIANCE)
	}

	toggleNavigation() {
		const { commit } = this.$store
		commit(APP_SET_NAVIGATION_STATUS)
	}

	trackClick(text: string) {
		switch (text) {
			case 'Franquias':
				CaptureEvent(Events.DashboardFranchiseView)
				break
			case 'Credito Imobiliario':
				CaptureEvent(Events.DashboardCIView)
				break
			case 'Rank Produtividade':
				CaptureEvent(Events.DashboardRPView)
				break
		}
	}

	/**
	 * If iSolve is accessed by a route, update the menu active state
	 */
	@Watch('$route.name', { immediate: true })
	onRouteNameChange() {
		this.updateMenuActiveState(this.$route.name)
	}
}
